import { changePasswordConstants, configConstants } from '../_constants';
import { changePasswordService } from '../_services';
import { utilityHelper } from '../_helpers';
/**
 * changePasswordActions
 *
 * @package                onboard
 * @subpackage             changePasswordActions
 * @category               Actions
 * @DateOfCreation         15 May 2019
 * @ShortDescription       This is responsible to handle all action related to change password
 */
export const changePasswordActions = {
    passwordUpdate,
    resetState
};

/**
* @DateOfCreation        15 May 2019
* @ShortDescription      This function is responsible for submit the change password form
* @param                 JSON user, This contains full user input data 
* @return                JSON Object
*/
function passwordUpdate(passwordDetail) {
    return dispatch => {
        dispatch(request({ passwordDetail }));
        changePasswordService.passwordUpdate(passwordDetail)
            .then(
                response => { 
                    let responseData = response.data;
                    if(response.status === configConstants.SUCCESS_CODE){
                        // sessionService.saveSession(responseData.data.token);
                        // sessionService.saveUser(responseData.data.userInfo);
                        //utilityHelper.setUpdateUserInfo('esConsent', false)
                        let successMsg = responseData.message;
                        dispatch(success(successMsg));
                    }else if(response.status === configConstants.BAD_REQUEST_CODE){
                        let errorMsg = responseData.message;
                        dispatch(failure(errorMsg));
                    }else if(response.status === configConstants.EXCEPTION_CODE){
                        let errorMsg = responseData.message;
                        dispatch(failure(errorMsg));
                    }else if(response.status === configConstants.UNAUTHENTICATE_CODE){
                        dispatch(unauthorize(responseData.message));
                    }else{
                        dispatch(failure(response));
                    }
                }
            ).catch(function (response) {
                dispatch(failure(response));
            });
    };
    
    // Actions defination that will perform according dispatch call and send data to reducer
    function request(passwordDetail) { return { type: changePasswordConstants.PASSWORD_REQUEST, passwordDetail} }
    function success(success) { return { type  : changePasswordConstants.PASSWORD_SUCCESS, success } }
    function failure(error)  { return { type  : changePasswordConstants.PASSWORD_FAILURE, error } }
    function unauthorize(error) { return { type: configConstants.UNAUTHENTICATE, error } }
}

/**
* @DateOfCreation        28 May 2019
* @ShortDescription      This function is responsible to update the states and props
* @return                JSON Object
*/
function resetState(){
    return dispatch => { dispatch(request());}
    function request() { return { type: changePasswordConstants.PASSWORD_RESET } }
}

